import React, { useCallback, useEffect, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  cancellationSelector,
  inclusionExclusionSelector,
  otherInformationSelector,
  secureTripSelector,
  reviewSelectedSelector,
  specialRequestSelector,
  reviewHeaderSelector,
  travellerDetailsSelector,
  AddressUpdateSelector,
  isLoggedInSelector,
  exactLocationApplicableSelector,
  safetyInformationSelector,
  travellerError,
  displayGstinSelector,
  sourceAsGstinSelector,
  travellerTitleDetailsSelector,
  fareSelector,
  languageSelector,
  loaderSelector
} from "../../redux/selector";
import { sourceSelector } from "../../../../common/redux/selector";
import CancellationPolicy from "../../../../../stories/components/cars/reviewpage/CancellationPolicy/CancellationPolicyUI";
import InclusionExclusionUI from "../../../../../stories/components/cars/reviewpage/InclusionExclusion/InclusionExclusionUI";
import ImportantInformationUI from "../../../../../stories/components/cars/reviewpage/ImportantInformation/ImportantInformationUI";
import SecureYourTripUI from "../../../../../stories/components/cars/reviewpage/SecureYourTrip/SecureYourTripUI";
import TravellerDetailsContainerUI from "../../../../../stories/components/cars/reviewpage/TravellerDetailsContainer/TravellerDetailsContainerUI";
import { scrollToTop, signIn } from "../../../../config/utils";
import PickupAddressUI from "../../../../../stories/components/cars/reviewpage/PickupAddress/PickupAddressUI";
import { fetchPriceResults, fetchReview } from "../../redux/thunks";
import SafetyInformationUI from "../../../../../stories/components/cars/reviewpage/SafetyInformation/SafetyInformationUI";
import { gcBookingReviewScreen, lob, pushCtaOmniEvents, sendEventOnError } from "../../../../../shared/config/omni";
import * as S from "./ReviewItems.styles";
import { BillingDetailsDweb } from '@growth/billing-details/dweb'
import { EXACT_LOCATION_ERROR, MOB_CABS_REVIEW, REVIEW_ITEMS, CABS_REVIEW_ROUTE, GSTIN_SUBMIT_ERROR, LOGIN_NOW, CABS_REVIEW_PAGE, SET_PICKUP_AS_GSTIN_SELECTED, SET_PICKUP_AS_GSTIN_UNSELECTED, OS_ADDON, SHOWN, REMOVED, SELECTED } from "../../../../../shared/utils/util-constants";
import { CTA_TYPE, getActionNameForOmniture } from "../../../../../shared/utils/omni-utils";
import { UPDATE_TRAVELLER_DETAILS } from "../../../SearchPage/redux/action-types";
import OsAddon, { OsAddonList } from "../../../../../stories/components/cars/reviewpage/OsAddons/OsAddon";
import { DISPLAY_GSTIN, UPDATE_REVIEW_SELECTED_DATA, UPDATE_SELECTED_ADDONS, UPDATE_SELECTED_LANGUAGE, UPDATE_SOURCE_AS_GSTIN } from "../../redux/action-types";

const ReviewItems = (props) => {
  const dispatch = useDispatch();
  const cancellationData = useSelector(cancellationSelector);
  const inclusionExclusion = useSelector(inclusionExclusionSelector);
  const otherInformation = useSelector(otherInformationSelector);
  const safetyInformation = useSelector(safetyInformationSelector);
  const secureTrip = useSelector(secureTripSelector);
  const reviewdetailsData = useSelector(reviewSelectedSelector);
  const specialRequest = useSelector(specialRequestSelector);
  const source = useSelector(sourceSelector);
  const reviewHeader = useSelector(reviewHeaderSelector);
  const travellerDetails = useSelector(travellerDetailsSelector);
  const travellerTitle = useSelector(travellerTitleDetailsSelector);
  const isAdreesUpdate = useSelector(AddressUpdateSelector);
  const isLoggedIn = useSelector(isLoggedInSelector);
  const exactLocationApplicable = useSelector(exactLocationApplicableSelector);
  const displayGstin = useSelector(displayGstinSelector)
  const sourceAsGstin = useSelector(sourceAsGstinSelector)
  const reviewPriceData = useSelector(fareSelector)
  const tError = useSelector(travellerError);
  const selectedLanguage : string = useSelector(languageSelector)
  const loaders = useSelector(loaderSelector);
  const { pay = true } = loaders;

  const [addonList, setAddonList] = useState<Array<OsAddonList>>([])
  const updateSelectedData = useCallback(
    (reviewSelectedData) => {
      dispatch({
        type: UPDATE_REVIEW_SELECTED_DATA,
        reviewSelectedData,
      });
    },
    [dispatch]
  );
  const onUpdateTravellerDetails = useCallback(
    (travellerDetails) => {
      dispatch({
        type: UPDATE_TRAVELLER_DETAILS,
        travellerDetails,
      });
    },
    [dispatch]
  );
  const onSuggestUpdate = useCallback(() => {
    dispatch(fetchReview(true));
    scrollToTop(0);
  }, [dispatch]);

  useEffect(() => {
    if (exactLocationApplicable) {
      pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${EXACT_LOCATION_ERROR}`, CTA_TYPE.HYPER_LINK, REVIEW_ITEMS, CABS_REVIEW_ROUTE)
      sendEventOnError([{
        field: 'address',
        message: 'Exact location needs to be updated'
      }])
    }
  }, [exactLocationApplicable])

  useEffect(() => {
    if (reviewPriceData?.travel_addons?.length) {
      let addonShown = ""
      const addonListData = reviewPriceData.travel_addons.map((addon, index) => {
        addonShown += addonShown?.length ? `_${addon?.id}` : `${addon?.id}`
        return {
          name : addon?.title,
          subtitle: addon?.sub_title,
          selected: reviewPriceData?.selected_addons ? (reviewPriceData?.selected_addons[addon?.id] || false) : false,
          id: addon?.id,
          price: addon?.price,
          notSelectOnClick: true,
          showBorder: index > 0,
          infoText: addon?.info_text,
          options: addon?.options,
        }
      })

      setAddonList(addonListData)
      
      pushCtaOmniEvents(
        `${MOB_CABS_REVIEW}_${OS_ADDON}_${addonShown}_${SHOWN}`,
        CTA_TYPE.HYPER_LINK,
        CABS_REVIEW_PAGE,
        CABS_REVIEW_ROUTE
      );
    }
  }, [reviewPriceData])

  const onGstinSameSourceCheckbox = (value) => {
    pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, value ? SET_PICKUP_AS_GSTIN_SELECTED : SET_PICKUP_AS_GSTIN_UNSELECTED, false) , CTA_TYPE.RADIO_BUTTON, CABS_REVIEW_PAGE, CABS_REVIEW_ROUTE)
    dispatch({
      type: UPDATE_SOURCE_AS_GSTIN,
      sourceAsGstin: value
    })
    const elem = document.getElementById("gstinContainer")
    if (elem) {
      elem.style.display = value ? "none" : "block"
    }
  }

  const updateLanguage = (optionId) => {
    dispatch({
      type: UPDATE_SELECTED_LANGUAGE,
      selectedLanguage: optionId ? optionId : ""
    })
  }

  const handleLanguageClick = (optionId) => {
    const selectedAddons = {...reviewPriceData?.selected_addons}
    if(optionId){
      dispatch({
        type: UPDATE_SELECTED_LANGUAGE,
        selectedLanguage: optionId
    })

    pushCtaOmniEvents(
      `${MOB_CABS_REVIEW}_${OS_ADDON}_${optionId}_${SELECTED}`,
      CTA_TYPE.RADIO_BUTTON,
      CABS_REVIEW_PAGE,
      CABS_REVIEW_ROUTE
    );
    dispatch(fetchPriceResults({selectedAddonsVal: selectedAddons}))
   }
  }

  const onAddonClick = (id, optionId) => {
    const selectedAddons = {...reviewPriceData?.selected_addons}
    let isSelected = false

    if (selectedAddons[id]) {
      delete selectedAddons[id]
      if(optionId){
        updateLanguage("")
      }
    } else {
      isSelected = true
      selectedAddons[id] = true
      if(optionId){
        updateLanguage(optionId)
      }
    }

    dispatch({
      type: UPDATE_SELECTED_ADDONS,
      selectedAddons
    })

    pushCtaOmniEvents(
      `${MOB_CABS_REVIEW}_${OS_ADDON}_${id}_${isSelected ? SELECTED : REMOVED}`,
      CTA_TYPE.RADIO_BUTTON,
      CABS_REVIEW_PAGE,
      CABS_REVIEW_ROUTE
    );

    dispatch(fetchPriceResults({selectedAddonsVal: selectedAddons}))
  }

  return (
    <>
      <InclusionExclusionUI {...inclusionExclusion} />
      {reviewPriceData?.travel_addons?.length ? (
      <OsAddon 
        onItemClick={onAddonClick}
        checkboxList={addonList}
        handleLangaueClick={handleLanguageClick}
        selectedLanguage={selectedLanguage}
        showLoader={pay}
      />
      ) : null}

      <PickupAddressUI
        heading="Pickup Address"
        cityName={reviewHeader?.source_city}
        address="Gali no 6, Rajiv Chowk, New delhi"
        cta="View on Map"
        margin="0 0 2rem 0"
        source={reviewHeader.source || source?.name}
        handleMap={[]}
        {...source}
        onSuggestUpdate={onSuggestUpdate}
        isAdreesUpdate={exactLocationApplicable ? 'Exact location needs to be updated' : isAdreesUpdate}
        exactLocationApplicable={exactLocationApplicable}
        displayGstin={displayGstin}
        sourceAsGstin={sourceAsGstin}
        isLoggedIn={isLoggedIn}
        onGstinSameSourceCheckbox={onGstinSameSourceCheckbox}
      />
      <S.GstinContainer id="gstinContainer">
        <BillingDetailsDweb
          onError={(error) => {
            pushCtaOmniEvents(`${MOB_CABS_REVIEW}_${GSTIN_SUBMIT_ERROR}`, CTA_TYPE.HYPER_LINK, REVIEW_ITEMS, CABS_REVIEW_ROUTE)
            sendEventOnError([{
              field: 'gstinSubmitError',
              message: 'Confirm and save billing details to your profile'
            }])
            scrollToTop(1650)
          }}
          onLoad={() => dispatch({
            type: DISPLAY_GSTIN,
            displayGstin: true
          })}
          onSuccess={props?.onBillingDetailsSuccess}
          ref={props?.billingDetailsRef}
          lobName={lob}
        />
      </S.GstinContainer>
      {(Object.keys(secureTrip)?.length) ? (
        <SecureYourTripUI
          {...secureTrip}
          margin="0 0 2rem 0"
          updateSelectedData={updateSelectedData}
          insurance_opted={reviewdetailsData?.insurance_opted}
        />
      ) : null}
      <TravellerDetailsContainerUI
        heading="Traveller details"
        infoText={isLoggedIn ? "" : "SignIn/SignUp to speed up your booking process"}
        margin="0 0 2rem 0"
        login={() => {
          pushCtaOmniEvents(getActionNameForOmniture(gcBookingReviewScreen, LOGIN_NOW), CTA_TYPE.HYPER_LINK, REVIEW_ITEMS, CABS_REVIEW_ROUTE)
          signIn()
        }}
        travellerTitle={travellerTitle}
        travellerDetails={travellerDetails}
        specialRequest={specialRequest}
        updateSelectedData={updateSelectedData}
        onUpdateTravellerDetails={onUpdateTravellerDetails}
        sr={reviewdetailsData?.s_r || []}
        error={tError}
      />
      <CancellationPolicy cancellationData={cancellationData} />
      <SafetyInformationUI {...safetyInformation} margin="0 0 2rem 0" />
      <ImportantInformationUI {...otherInformation} margin="0 0 2rem 0" />
    </>
  );
};

export default React.memo(ReviewItems);
